import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { CurrencyTD, Table, Tr, Td } from "commons";

export class AccountDetails extends Component {
    makeFeeRow = () =>
        this.props.accountDetails.accountDetails.annualAdviserFeePercentage !== 0 ? (
            <Td>{this.props.accountDetails.accountDetails.annualAdviserFeePercentage}%</Td>
        ) : (
            <CurrencyTD
                amount={this.props.accountDetails.accountDetails.annualAdviserFeeAmount}
                align="left"
            />
        );

    render() {
        if (!(this.props.accountDetails && this.props.clientDetails)) {
            return <div />;
        }
        const name =
            this.props.clientDetails.forename === null
                ? `${this.props.clientDetails.surname}`
                : `${this.props.clientDetails.forename} ${this.props.clientDetails.surname}`;
        return (
            <Details>
                <Table>
                    <tbody>
                        <Tr>
                            <Td>Client name:</Td>
                            <Td>{name}</Td>
                        </Tr>
                        <Tr>
                            <Td>Client reference:</Td>
                            <Td>{this.props.clientDetails.clientId}</Td>
                        </Tr>
                        <Tr>
                            <Td>Account number:</Td>
                            <Td>{this.props.accountDetails.accountNumber}</Td>
                        </Tr>
                        <Tr>
                            <Td>Account type:</Td>
                            <Td>{this.props.accountDetails.wrapperType}</Td>
                        </Tr>
                        <Tr>
                            <Td>Advice fee (annual):</Td>
                            {this.makeFeeRow()}
                        </Tr>
                    </tbody>
                </Table>
            </Details>
        );
    }
}

export const Details = styled.div`
    float: left;
    width: 40%;
`;

AccountDetails.propTypes = {
    clientDetails: PropTypes.shape({
        forename: PropTypes.string,
        surname: PropTypes.string,
        clientId: PropTypes.number
    }),
    accountDetails: PropTypes.shape({
        accountNumber: PropTypes.string,
        wrapperType: PropTypes.string,
        accountDetails: PropTypes.shape({
            annualAdviserFeePercentage: PropTypes.number,
            annualAdviserFeeAmount: PropTypes.number
        })
    })
};
